// Categories mirror docs/PRODUCT_CONTEXT.md §9. Each category's `keywords` decide
// which /search/{slug} pages it applies to (matched as substrings against the current
// search term, same approach as infoGuides.js); `terms` are the curated adjacent
// searches shown as links. Hardcoded rather than pulled from a live term-frequency
// source (same tradeoff as PopularSearches.jsx) - keeps the reverse-link graph between
// search pages free of any new runtime dependency. If a term hasn't been published to
// KV yet, the Cloudflare Worker 302-redirects to the live SPA search, never a dead end.
const relatedSearchCategories = [
  {
    id: 'electronics',
    keywords: ['airpods', 'anker', 'samsung', 'sony', 'gopro', 'earbuds', 'headphone'],
    terms: [
      'AirPods Pro',
      'Anker PowerCore',
      'GoPro Hero',
      'Sony WH-1000XM5',
      'Samsung Galaxy Buds',
    ],
  },
  {
    id: 'babyToddler',
    keywords: ['pampers', 'bugaboo', 'britax', 'fisher-price', 'fisher price', 'lego', 'stroller'],
    terms: ['Lego', 'Fisher-Price', 'Bugaboo Stroller', 'Britax Car Seat', 'Pampers'],
  },
  {
    id: 'clothing',
    keywords: ['nike', 'adidas', 'calvin klein', "levi's", 'levis', 'new balance'],
    terms: ["Nike Air Max", 'Adidas Ultraboost', "Levi's 501", 'Calvin Klein', 'New Balance 574'],
  },
  {
    id: 'homeAppliances',
    keywords: [
      'kitchenaid',
      'ninja',
      'dyson',
      'roomba',
      'instant pot',
      'nespresso',
      'melitta',
      'sage',
      'delonghi',
      "de'longhi",
      'espresso',
      'coffee',
    ],
    terms: [
      'Melitta Solo',
      'Sage Barista Express',
      'Instant Pot Duo',
      'Dyson V15',
      'Ninja Foodi',
      'KitchenAid Mixer',
    ],
  },
  {
    id: 'cosmetics',
    keywords: ['cerave', 'the ordinary', 'olaplex', 'maybelline', 'nyx'],
    terms: ['CeraVe Moisturizing Cream', 'The Ordinary Niacinamide', 'Olaplex No 3', 'Maybelline Mascara'],
  },
  {
    id: 'sportsGear',
    keywords: ['under armour', 'brooks', 'garmin', 'fitbit', 'north face'],
    terms: ['Fitbit Charge', 'Garmin Forerunner', 'Under Armour', 'North Face Jacket', 'Brooks Ghost'],
  },
  {
    id: 'books',
    keywords: ['textbook', 'novel', "children's book", 'childrens book'],
    terms: ['Bestselling Novels', "Children's Books", 'Programming Textbooks'],
  },
];

export default relatedSearchCategories;
